// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"be0d2136","667":"500e05fb","977":"d676d9e0"}[chunkId] + ".chunk.js";
};